import { render, staticRenderFns } from "./BalanceMensualItem.vue?vue&type=template&id=568f8074&scoped=true&"
import script from "./BalanceMensualItem.vue?vue&type=script&lang=js&"
export * from "./BalanceMensualItem.vue?vue&type=script&lang=js&"
import style0 from "./BalanceMensualItem.vue?vue&type=style&index=0&id=568f8074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568f8074",
  null
  
)

export default component.exports